import { LanguageType } from '@/models/LanguageType';
import { LocaleData } from '@/translations/LocaleData';

export enum LocaleTypes {
    SET = '@locale/SET',
    SET_CURRENT_CONTENT_LANGUAGE = '@locale/SET_CURRENT_CONTENT_LANGUAGE',
    SET_CURRENT_CONTENT_SUBTITLE = '@locale/SET_CURRENT_CONTENT_SUBTITLE',
    CLEAR_CURRENT_CONTENT_LANGUAGE = '@locale/CLEAR_CURRENT_CONTENT_LANGUAGE',
    SET_LOCALE_REQUEST = '@locale/SET_LOCALE_REQUEST',
    SET_LOCALE_SUCCESS = '@locale/SET_LOCALE_SUCCESS',
    SET_LOCALE_FAILURE = '@locale/SET_LOCALE_FAILURE',
    GET_CONTENT_LOCALE_REQUEST = '@locale/GET_CONTENT_LOCALE_REQUEST',
    GET_CONTENT_LOCALE_SUCCESS = '@locale/GET_CONTENT_LOCALE_SUCCESS',
    GET_CONTENT_LOCALE_FAILURE = '@locale/GET_CONTENT_LOCALE_FAILURE',
    SET_CONTENT_LOCALE_REQUEST = '@locale/SET_CONTENT_LOCALE_REQUEST',
    SET_CONTENT_LOCALE_SUCCESS = '@locale/SET_CONTENT_LOCALE_SUCCESS',
    SET_CONTENT_LOCALE_FAILURE = '@locale/SET_CONTENT_LOCALE_FAILURE',
}

export interface LocaleState {
    data: LocaleData;
    availableContentLanguages: LanguageType[];
    currentContentLanguage: LanguageType;
    currentContentSubtitle: LanguageType;
    loading: boolean;
    hasError: boolean;
}
